export class OrganizationSourcingSettingsApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get Organization Sourcing Settings
     * @returns OrganizationSourcingSettings
     * @throws ApiError
     */
    getOrganizationSourcingSettings() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/organization-sourcing-settings',
        });
    }
    /**
     * Update Organization Sourcing Settings
     * @returns any
     * @throws ApiError
     */
    updateOrganizationSourcingSettings({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/organization-sourcing-settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
